export default __webpack_public_path__ + "static/media/bambino-baby-cabbage-snack-attack.d62ece09.png";